<template>
  <div class="panel-block is-justify-content-space-between">
    <label class="checkbox">
      <input
        ref="inputRef"
        :checked="modelValue"
        type="checkbox"
        :data-test-id="testId"
        @change="handleChange"
      />
      <span>{{ label }}</span>
    </label>
    <div class="is-flex is-align-items-center">
      <slot name="actions" />
      <IconHint v-if="hint" :content="hint" :interactive="interactive" />
    </div>
  </div>
</template>

<script setup>
  import { ref, inject, nextTick } from "vue";
  import IconHint from "../icon-hint.vue";

  defineProps({
    modelValue: { type: Boolean, required: true },
    label: { type: String, required: true },
    hint: { type: String, default: "" },
    interactive: { type: Boolean, default: false },
    testId: { type: String, default: "" },
  });

  const emit = defineEmits(["update:modelValue"]);
  const inputRef = ref(null);
  const triggerSave = inject("triggerSave", null);

  async function handleChange(event) {
    const newValue = event.target.checked;

    // Update store via v-model
    emit("update:modelValue", newValue);

    // Wait for Vue reactivity to complete before triggering save
    await nextTick();

    // Trigger autosave directly
    if (triggerSave) {
      triggerSave();
    }
  }
</script>
